/**
 * Vuex modules
 * @link https://vuex.vuejs.org/guide/modules.html
 */
import * as crudStore   from "./crud";
import * as globalStore   from "./global";
import * as authStore  from "./auth";
import * as configStore from "./config";
export default { globalStore, crudStore, authStore, configStore};
